import React, { Fragment, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

//components
import Item from '../components/Item';
import ServicesSearch from '../services/ServicesSearch';

import history from '../history';
import Loader from 'react-loader-spinner';

const PymesContent = () => {
  const limit = 12;
  const [pymes, setPymes] = useState([]);
  const [loader, setLoader] = useState(true);

  const redirectTo = (route) => {
    history.push(route);
  };

  const getData = () => {
    let params = {
      _size: limit,
      _random: uuidv4(),
    };

    ServicesSearch.getDataPyme(params)
      .then((response) => {
        setPymes(response.data['hits']);
        setLoader(false);
      })
      .catch((e) => {
        setLoader(false);
        console.log(e);
      });
  };

  useEffect(getData, []);

  return (
    <Fragment>
      <div className="row">
        <div className="col-md-12 m-b-35" style={{ marginTop: '35px' }}>
          <h3>Encuentra lo mejor del emprendimiento nacional</h3>
        </div>{' '}
        {loader ? (
          <div className="spinner-d">
            <Loader
              type="Oval"
              color="#00BFFF"
              height={50}
              width={50}
              className="spinner-1"
            />
          </div>
        ) : (
          pymes.map((pyme, index) => (
            <Item
              key={index}
              width={'3'}
              image={pyme._source.imagePymeURL}
              title={pyme._source.namePyme}
              specialFactor={pyme._source.specialFactor !== undefined ? pyme._source.specialFactor : ''}
              obj={pyme}
            />
          ))
        )}
      </div>
      <div className={'row align-items-center ' + (loader ? 'hidden' : '')}>
        <div className="col-sm-8 col-md-3" style={{ margin: 'auto' }}>
          <button
            className="btn btn-btn-lg btn-block btn-mas-pymes mt-3 px-4"
            onClick={() => redirectTo('search')}
          >
            Ver más pymes
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default PymesContent;
